export default __webpack_public_path__ + "static/media/exterior10.38b0a61d.jpg";